module.exports = __webpack_public_path__ + "img/freespin3_multiplier6.bc4703fa.png";